import axios from "axios";
import Feedback from "../../adapters/feedback-adapter";
import store from "./../index";

export default {
  namespaced: true,
  state: {
    feedbacks: [],
  },

  mutations: {
    setFeedbacks(state, payload) {
      state.feedbacks = payload;
    },
  },
  actions: {
    getFeedbacks({ commit }) {
      store.commit("setLoader", true);
      return axios
        .get(`/home/feedbacks`)
        .then((response) => {
          const res = response.data.data.feedbacks;
          let lang = store.state.lang;
          commit(
            "setFeedbacks",
            res.map((i) => {
              return new Feedback(i, lang);
            })
          );
          return true;
        })
        .catch(() => {
          return false;
        });
    },
  },
};
